import { FC } from 'react';

import useStore from '../store/useStore';

import TaskPaneContainer from './TaskPaneContainer';
import SendosoPane from './SendosoPane';
import EmailPane from './EmailPane';
import CallPane from './CallPane';
import GeneralTaskPane from './GeneralTaskPane';
import SmsPane from './SmsPane';
import LinkedInPane from './LinkedInPane';

const MainContainer: FC = () => {
  const type = useStore(store => store.action?.type);
  let mainPane = <GeneralTaskPane />;

  if (type === 'TEMPLATE') {
    mainPane = <EmailPane />;
  } else if (type === 'CALL') {
    mainPane = <CallPane />;
  } else if (type === 'STEP_SUBTYPE_SMS') {
    mainPane = <SmsPane />;
  } else if (type === 'STEP_SUBTYPE_SENDOSO') {
    mainPane = <SendosoPane />;
  } else if (
    type === 'STEP_SUBTYPE_LINKEDIN_INMAIL' ||
    type === 'STEP_SUBTYPE_LINKEDIN_CONNECT'
  ) {
    mainPane = <LinkedInPane />;
  }

  return (
    // We need min height = 0 to make overflow work
    <div className="relative flex flex-row flex-1 w-full min-h-0 bg-white">
      <TaskPaneContainer />
      {mainPane}
    </div>
  );
};

export default MainContainer;
